import * as React from "react";
export const Container = props => React.createElement("div", { className: `g-container ${props.className ? ` ${props.className}` : ""}` }, props.children);
